<template>
  <slotModal
    id-modal="modalContoh"
    modal-title="Modal ya kan!"
    v-model="dialog"
    @close="close"
  >
    <template v-slot:modal-content>
      <p class="f-Overpass f-w-400 f-14">ini isi dari content nya</p>
    </template>
  </slotModal>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";

export default {
  name: "modalContoh",
  components: {
    slotModal,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    // tes(a) {
    //   console.log(a);
    // },
  },
};
</script>
